import { apiClient } from '@app/api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ReportView } from '@app/core/reports/components/ReportView';
import { DateTimeStr, toDateTimeStr, toTimestamp } from '@mi-front/core';
import moment from 'moment';
import { LowerthirdReport, StationLowerthirdType } from '../../types';
import { LowerthirdForm } from './components/form/filters';
import { LowerthirdResult } from './components/result/result';

export function LowerthirdView() {
  const tz = useTimezone();

  return (
    <ReportView<LowerthirdReport>
      defaultValues={{
        station: { slug: '' },
        from: toDateTimeStr(moment().tz(tz).startOf('day').toISOString()),
        to: toDateTimeStr(moment().tz(tz).endOf('day').toISOString()),
        pageSize: 50,
        pageIndex: 0,
      }}
      download={false}
      queryParamsTransform={{}}
      reportFn={async (values: {
        station: StationLowerthirdType;
        from: DateTimeStr;
        to: DateTimeStr;
      }) => {
        return values.station.slug
          ? apiClient.audit.fetchLowerthirdRange(values.station.slug, {
              from: toTimestamp(values.from),
              to: toTimestamp(values.to),
            })
          : [];
      }}
      Form={LowerthirdForm}
      Result={LowerthirdResult}
    />
  );
}
